<template>
  <section>
    <div class="container grid-xl">
      <div class="columns">
        <div class="column col-xl-12">
          <h1 class="site_hero">{{motto}}</h1>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// import sButton from './sButton.vue';
export default{
  name: 'Hero',
  props: {
    motto:{
      type: String,
      required: true
    }
  },
  methods:{
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  .site_hero{
    padding: 1rem 0;
    font-family: 'Work Sans', sans-serif;
    font-weight: 900;
    color: #3b4351;
  }
  @media screen and (min-width: 1441px){
    .site_hero{
      padding-bottom: 2rem;
      margin-top: 1rem;
      font-size: 3rem;
      margin-left: -3.5rem;
    }
  }
</style>
